(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/tipsen/engine/assets/javascripts/services.js') >= 0) return;  svs.modules.push('/components/tipsen/engine/assets/javascripts/services.js');
"use strict";

var _svs$core$config$data;
const {
  resolveProductId,
  productIds,
  getSpecificDrawName
} = svs.utils.products;
const {
  pay
} = svs.lbUtils.wager;
const {
  jupiter,
  log
} = svs.core;
const {
  signIndexToOutcome
} = svs.components.sport.tipsenShared;
const {
  formatDate
} = svs.components.lbUtils.helpers;
const {
  selfserviceCart
} = svs.components;
const {
  EventTypeId
} = svs.components.sportinfo.common.constants;
const {
  SportPixWagerSystemTypes
} = svs.components.tipsen.engine.constants;
const {
  selectEngineDefinitionByProductId
} = svs.components.tipsen.engine.selectors;
const {
  getProductConfigDataByDraw
} = svs.components.lbUtils.brandMapping.fn;
const {
  actions,
  PARAM_ACTION
} = svs.components.sport.tipsenShared;
const extraOptions = {
  url: {
    params: [[PARAM_ACTION, actions.PAY]]
  }
};
const isSelfService = (_svs$core$config$data = svs.core.config.data) !== null && _svs$core$config$data !== void 0 && (_svs$core$config$data = _svs$core$config$data.svsconfig) !== null && _svs$core$config$data !== void 0 && _svs$core$config$data.isSelfService ? svs.core.config.data.svsconfig.isSelfService : false;
const addonProductName = {
  [productIds.STRYKTIPSET]: 'Fullträff Stryktipset',
  [productIds.T8STRYK]: 'Fullträff Topptipset'
};
const getProductName = wagerProp => {
  const productId = resolveProductId(wagerProp.productId);
  return addonProductName[productId];
};
const placeSelfServiceBet = wagerWrapper => new Promise((resolve, reject) => {
  selfserviceCart.getCartInstance().actions.addItem(wagerWrapper, err => {
    if (err) {
      reject(err);
    } else {
      resolve();
    }
  });
});
const handleSelfServiceBet = async (wagers, wagersProps, draws, onPaymentDone) => {
  let i = 0;
  try {
    for (; i < wagers.length; i++) {
      var _activeWagerProps$ext, _activeWagerProps$ext2;
      const activeWager = wagers[i];
      const activeWagerProps = wagersProps[i];
      const activeDraw = draws[i];
      const {
        displayName,
        brandLogo,
        unknownProduct
      } = getProductConfigDataByDraw(activeDraw, resolveProductId(activeWagerProps.productId));
      let addonProductName;
      if (wagers.length > 1 && i) {
        addonProductName = getProductName(wagersProps[0]);
      }
      const productTitle = unknownProduct ? undefined : displayName;
      const productBrand = unknownProduct ? undefined : brandLogo;
      const productFlag = productTitle || activeWagerProps.productId;
      const cost = activeWagerProps.message.price;
      const regCloseTime = new Date((_activeWagerProps$ext = (_activeWagerProps$ext2 = activeWagerProps.extradata) === null || _activeWagerProps$ext2 === void 0 ? void 0 : _activeWagerProps$ext2.regCloseTime) !== null && _activeWagerProps$ext !== void 0 ? _activeWagerProps$ext : null);
      const description = "Spelstopp: ".concat(formatDate.formatDate(regCloseTime, true, true));
      const productItemInfo = {
        wagers: activeWager,
        isLive: false,
        headers: {
          source: 'SvS:LB:ITS'
        },
        productFlag,
        productTitle,
        productBrand,
        cost,
        description,
        addonProductName
      };
      const wagerWrapper = selfserviceCart.generateProductItem(productItemInfo);
      await placeSelfServiceBet(wagerWrapper);
    }
    onPaymentDone(null, {
      wagerCount: i
    });
  } catch (err) {
    onPaymentDone(err, {
      wagerCount: i
    });
  }
};
const logger = log.getLogger('tipsen:placeBetService');
const placeBetService = function (wager, wagerProps, draw) {
  let overrideErrorHandling = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
  return new Promise((resolve, reject) => {
    const draws = [].concat(draw);
    const wagers = [].concat(wager);
    const wagersProps = [].concat(wagerProps);
    logger.info(JSON.stringify(wager));
    if (isSelfService) {
      if (selfserviceCart !== null && selfserviceCart !== void 0 && selfserviceCart.getCartInstance && selfserviceCart !== null && selfserviceCart !== void 0 && selfserviceCart.generateProductItem) {
        handleSelfServiceBet(wagers, wagersProps, draws, (error, data) => {
          if (error && data.wagerCount.length === 0) {
            reject(error);
          } else {
            resolve({
              wagerCount: data.wagerCount,
              totalWagerCount: wagers.length
            });
          }
        });
      } else {
        reject(new Error('selfservice-cart is not loaded'));
      }
    } else {
      pay(wager, wagerProps, response => {
        resolve(response);
      }, error => {
        reject(error);
      }, null, overrideErrorHandling, extraOptions);
    }
  });
};
const SportPixFlavour = {
  Balanced: 'Balanced',
  Safe: 'Safe'
};
const normalizeRow = (event, eventTypeId) => {
  const signsForEventType = Object.values(signIndexToOutcome[eventTypeId]);
  const signsForEventTypeLength = signsForEventType.length;
  const row = new Array(signsForEventTypeLength).fill(false);
  signsForEventType.forEach((sign, signIndex) => {
    const foundSign = Boolean(event.outcomes.find(el => el.value === sign));
    row[signIndex] = foundSign;
  });
  return row;
};
const normalizeBoard = (pix, board, eventTypeId) => {
  pix.events.forEach(event => {
    const eventIndex = event.eventNumber - 1;
    const row = normalizeRow(event, eventTypeId);
    board[eventIndex] = row;
  });
  return board;
};
const normalizeResponse = (res, systemType, eventTypeId) => {
  const boards = [];
  if (systemType === SportPixWagerSystemTypes.SROW) {
    res.pixes.forEach(pix => {
      let board = new Array(res.pixes[0].events.length).fill(null);
      board = normalizeBoard(pix, board, eventTypeId);
      boards.push(board);
    });
  } else {
    let board = new Array(res.pix.events.length).fill(null);
    board = normalizeBoard(res.pix, board, eventTypeId);
    boards.push(board);
  }
  return boards;
};

const generateSportPixService = _ref => {
  let {
    productId,
    drawNumber,
    flavour = SportPixFlavour.Safe,
    skewPercentage,
    size,
    guaranteedEvents = {
      events: []
    },
    systemType = SportPixWagerSystemTypes.XPERT_WAGER_MSYS,
    numRows
  } = _ref;
  return new Promise((resolve, reject) => {
    var _definition$outcomes$;
    if (!productId) {
      throw new Error('productId is required');
    }
    if (!drawNumber) {
      throw new Error('drawNumber is required');
    }
    if (!size) {
      throw new Error('size is required');
    }
    const definition = selectEngineDefinitionByProductId(productId);
    const productDrawName = getSpecificDrawName(productId);
    const path = "/wager/1/".concat(productDrawName, "/pix").concat(systemType === SportPixWagerSystemTypes.SROW ? '/singlerows' : '');
    const pixType = definition.pixType;
    const flavourValue = "".concat(flavour).concat(pixType);
    const params = new URLSearchParams();
    params.append('drawNumber', drawNumber);
    params.append('flavour', flavourValue);
    params.append('systemNumberMapping', size);
    if (systemType !== SportPixWagerSystemTypes.SROW) {
      params.append('systemType', systemType);
    } else {
      params.append('numRows', numRows);
    }
    if (skewPercentage) {
      const minSkewPercentage = 0;
      const maxSkewPercentage = 100;
      params.append('skewPercentage', Math.min(Math.max(parseInt(skewPercentage, 10), minSkewPercentage), maxSkewPercentage));
    }
    const eventTypeId = (_definition$outcomes$ = definition === null || definition === void 0 ? void 0 : definition.outcomes.eventTypeId) !== null && _definition$outcomes$ !== void 0 ? _definition$outcomes$ : EventTypeId.EVENT_1X2;
    jupiter.post({
      path: "".concat(path, "?").concat(params.toString()),
      data: guaranteedEvents
    }, res => {
      const normalizedResponse = normalizeResponse(res, systemType, eventTypeId);
      resolve(normalizedResponse);
    }, error => {
      reject(error.responseJSON.error);
    });
  });
};
setGlobal('svs.components.tipsen.engine.services', {
  placeBetService,
  generateSportPixService
});

 })(window);